/**
 * @file
 * Global utilities.
 *
 */

/* global jQuery, Drupal, document */

(($, Drupal) => {
  /* eslint-disable no-param-reassign */
  // Drupal.theme.ajaxProgressBar = $element => $('<div class="ajax-progress ajax-progress-bar"></div>').append($element);
  Drupal.behaviors.scholarship_theme = {
    attach: () => {
      $('body').one('scholarship-theme').each(() => {

        $('.paragraph--type-accordion').one('accordions').each(function (index, element) {
          var $container = $(this);
          var $title = $('.accordion--title', $container);
          var $content = $('.accordion--content', $container);
          $content.slideUp();
          var containerClass = 'accordion-container-' + index;
          $title.on('click touch', function (e) {
            $container.toggleClass('expanded');
            $content.slideToggle();
          });
          $container.addClass(containerClass);
        });
      });
    },
  };
})(jQuery, Drupal);
